import React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { ProgressBar } from "react-native-paper";

const styles = StyleSheet.create({
  progressBar: {
    width: "98%",
    height: 7,
    marginTop: 10,
    borderRadius: 5,
    marginLeft: "auto",
    marginRight: "auto",
  },
});

interface ProgressBarProps {
  progress: number;
  animatedValue: number;
}

export default function ProgressBarComponent(props: ProgressBarProps) {
  return (
    <View className="w-full">
      <ProgressBar
        progress={props.progress}
        animatedValue={props.animatedValue}
        color="#5D0CBA"
        style={styles.progressBar as ViewStyle}
      />
    </View>
  );
}
